import { ChevronDownIcon } from '@heroicons/react/24/solid';
import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getSafeLanguage } from '@rebound/shared-models/utils';

type LanguageSelectProps = {
  localesOptions: Record<string, string>;
};

const LanguageSelect = ({ localesOptions }: LanguageSelectProps) => {
  const { i18n } = useTranslation();
  const currentLocale = getSafeLanguage(i18n);
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18next.changeLanguage(e.target.value);
  };

  return (
    <Wrapper>
      <StyledSelect onChange={handleSelect} value={currentLocale}>
        {Object.entries(localesOptions).map(([value, label], idx) => (
          <StyledOption key={idx} value={value}>
            {label}
          </StyledOption>
        ))}
      </StyledSelect>
      <StyledChevron />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
`;

const StyledSelect = styled.select`
  padding: 9px 35px 9px 17px;
  border: 1px solid ${({ theme }) => theme.colors.grayDark2};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  width: 100%;
  appearance: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

const StyledOption = styled.option`
  font-size: 16px;
  padding: 0 !important;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

const StyledChevron = styled(ChevronDownIcon)`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export default LanguageSelect;
